module.exports = __webpack_public_path__ + "static/media/ch.edb9e8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ch.svg
// module id = 2062
// module chunks = 0